import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { AuthGuard } from './components/Auth/AuthGuard'
import { SignIn } from './components/Auth/SignIn'
import { SignUp } from './components/Auth/SignUp'
import { Layout } from './components/Layout/Layout'

// Lazy load route components for code splitting
// These will be loaded on-demand, reducing initial bundle size
const WorkoutsPage = lazy(() => import('./pages/WorkoutsPage').catch(() => ({ default: () => <div>Workouts (Coming Soon)</div> })))
const NutritionPage = lazy(() => import('./pages/NutritionPage').catch(() => ({ default: () => <div>Nutrition (Coming Soon)</div> })))
const ProgressPage = lazy(() => import('./pages/ProgressPage').catch(() => ({ default: () => <div>Progress (Coming Soon)</div> })))

// Loading fallback component
function LoadingFallback() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-gray-400">Loading...</div>
    </div>
  )
}

function Home() {
  const { currentUser } = useAuth()
  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Welcome</h2>
      <p className="text-gray-400">
        {currentUser
          ? `Signed in as ${currentUser.email}`
          : 'Please sign in to continue'}
      </p>
    </div>
  )
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/signin" element={<SignIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route
        path="/"
        element={
          <AuthGuard>
            <Layout />
          </AuthGuard>
        }
      >
        <Route index element={<Home />} />
        <Route
          path="workouts"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <WorkoutsPage />
            </Suspense>
          }
        />
        <Route
          path="nutrition"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <NutritionPage />
            </Suspense>
          }
        />
        <Route
          path="progress"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <ProgressPage />
            </Suspense>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
